/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Barcode_Not_Found_TitleInputs */

const vi_pos_barcode_not_found_title = /** @type {(inputs: Pos_Barcode_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy sản phẩm`)
};

/**

* @param {Pos_Barcode_Not_Found_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_barcode_not_found_title = /** @type {((inputs?: Pos_Barcode_Not_Found_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Barcode_Not_Found_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_barcode_not_found_title(inputs)
});